import styled from 'styled-components';

export const JaneNameWrapper = styled.div<{ isUnderlined: boolean }>`
  ${({ theme }) => theme.fonts.PoppinsTextBold};
  color: ${({ theme }) => theme.colors.Grey7};
  font-size: 16px;
  line-height: 23px;
  ${({ theme }) => theme.common.Ellipsis};
  cursor: pointer;
  text-decoration: ${({ isUnderlined }) => (isUnderlined ? 'underline' : 'none')};
`;
